import { v4 as uuid } from "uuid";
export const blogsData = [
  {
    id: uuid(),
    name: "Difference between var let const",
    image: "https://miro.medium.com/max/1400/1*R2YxLJzDhqRNNQSxN492Mw.png",
    blog: "https://hashnode.com/post/difference-between-var-let-and-const-in-javascript-ckv2k4xj40r51sss1hdj408gz",
  },

  {
    id: uuid(),
    name: "Difference between == & ===",
    image: "https://codeahoy.com/assets/images/==-vs-===-in-Javascript.png",
    blog: "https://hashnode.com/post/difference-between-and-operators-in-javascript-ckv3nplrk0yi3sss115li1y81",
  },
];
